import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage/Homepage";
import Login from "./pages/Login/Login";
import SignUp from "./pages/SignUp/SignUp";
import Dashboard from "./pages/Dashboard/Dashboard";
import MyPoems from "./components/MyPoems";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { auth } from "./firebase"; // Ensure you have this import to access Firebase auth
import FeaturedPoems from "./components/FeaturedPoems";
import AddPoem from "./components/AddPoem";
import ApprovePoems from "./components/ApprovePoems";
import MyStories from "./components/MyStories";
import MyKnowledgeHub from "./components/MyKnowledgeHub";
import FeaturedStories from "./components/FeaturedStories";
import MyContent from "./components/MyContent";
import FeaturedKnowledge from "./components/FeaturedKnowledge";
import FeaturedEssays from "./components/FeaturedEssays";
import FeaturedScholarships from "./components/FeaturedScholarships";
import PoemPage from "./components/PoemPage";
import StoryPage from "./components/StoryPage";
import KnowledgePage from "./components/KnowledgePage";
import ScholarshipPage from './components/ScholarshipPage';
import EssayPage from "./components/EssayPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
//import ContentPage from "./components/ContentPage"

const App = () => {
  const [showButton, setShowButton] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div style={{ backgroundColor: "#F5F5DC", minHeight: "100vh" }}>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route exact path="/" element={<Homepage />} />
        <Route path="/poem/:poemId" element={<PoemPage />} />
        <Route path="/story/:storyId" element={<StoryPage />} />
        <Route path="/knowledge/:knowledgeId" element={<KnowledgePage />} />
        <Route path="/essay/:essayId" element={<EssayPage />} />
        <Route path="/scholarship/:scholarshipId" element={<ScholarshipPage />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/signup" element={<SignUp />} />
        <Route exact path="/dashboard" element={<Dashboard user={user} />} />
        <Route path="/my-poems" element={<MyPoems />} />
        <Route path="/my-content" element={<MyContent />} />
        <Route path="/my-stories" element={<MyStories />} />
        <Route path="/my-knowledge" element={<MyKnowledgeHub />} />
        <Route path="/add-poem" element={<AddPoem />} />
        <Route path="/featured-poems" element={<FeaturedPoems />} />
        <Route path="/featured-stories" element={<FeaturedStories />} />
        <Route path="/featured-knowledge" element={<FeaturedKnowledge />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />

        <Route
          path="/featured-scholarships"
          element={<FeaturedScholarships />}
        />
        <Route path="/featured-essay" element={<FeaturedEssays />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/approve-poems" element={<ApprovePoems />} />
        <Route
          path="*"
          element={
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
                <p className="text-gray-600 mb-4">Page not found</p>
                <a
                  href="/"
                  className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
                >
                  Back to Home
                </a>
              </div>
            </div>
          }
        />
      </Routes>

      {/* Back to Top Button */}
      {showButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-4 right-4 bg-blue-800 text-white py-2 px-4 rounded-full shadow-lg hover:bg-blue-700 transition"
        >
          ↑ Back To Top
        </button>
      )}
    </div>
  );
};

export default App;
